<template>
  <div class="team">
    <h1 class="blue-grey--text my-5 text-center">팀원 {{ users.length }}명</h1>
    <v-container>
      <v-row>
        <v-col
          v-for="(user, index) in users"
          :key="index"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="2"
        >
          <v-card outlined flat class="text-center" color="#ECEFF1">
            <v-responsive class="pt-6">
              <v-avatar size="100">
                <v-img
                  src="img/avatar.png"
                ></v-img>
              </v-avatar>
            </v-responsive>
            <v-card-text class="text-center">
              <p class="text-h6">{{ user.name }}</p>
              <p>{{ user.email }}</p>
            </v-card-text>
            <v-card-actions>
              <v-btn text>
                <v-icon left small>mdi-message-text-outline</v-icon>
                <span>Message</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import { db } from '../firebase/init'

export default {
  data(){
    return {
      users: []
    }
  },
  mounted(){
    let users = []
    db.collection("users").get().then(snapshot => {
      snapshot.forEach(doc => {
        let data = doc.data()
        users.push(data)
      })
      this.users = users;
    })
  }

}
</script>

<style>

</style>